console.log("contact-us");

$(document).ready(function () {
  $(".ui.form").form({
    inline: true,
    fields: {
      Name: {
        identifier: "Name",
        rules: [
          {
            type: "empty",
            prompt: "Please enter your name",
          },
        ],
      },
      Email: {
        identifier: "Email",
        rules: [
          {
            type: "empty",
            prompt: "Please enter your email",
          },
        ],
      },
      Mobile: {
        identifier: "Mobile",
        rules: [
          {
            type: "empty",
            prompt: "Enter your mobile number",
          },
          {
            type: "minLength[10]",
            prompt: "Please enter the valid mobile number",
          },
        ],
      },
    },
  });
});

$(document).ready(function () {
  $("#formSubmit").submit(function (e) {
    e.preventDefault();
    var firstname = $("input[name='Name']");
    var email = $("input[name='Email']");
    var mobile = $("input[name='Mobile']");
    var message = $("input[name='Message']");

    $.ajax({
      url: "contact.php",
      data: {
        firstname: firstname,
        email: email,
        mobile: mobile,
        message: message,
      },
      success: function (result) {
        // $("#div1").html(result);
        alert(result);
      },
    });
  });
});
